import {
  bootstrapApplication
} from '@angular/platform-browser';

import {
  provideRouter,
  Routes
} from '@angular/router';

import {
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';

import {
  LOCALE_ID
} from '@angular/core';

import {
  registerLocaleData
} from '@angular/common';

import localePt from '@angular/common/locales/pt';

import {
  AppComponent
} from './app/app.component';

import {
  authInterceptor
} from './app/core/auth.interceptor';

import {
  authGuard
} from './app/core/auth.guard';

import {
  PublicMenuComponent
} from './app/pages/public-menu/public-menu.component';

import {
  LoginComponent
} from './app/pages/login/login.component';

import {
  DashboardComponent
} from './app/pages/dashboard/dashboard.component';

import {
  RestaurantsComponent
} from './app/pages/restaurants/restaurants.component';

import {
  ProductsComponent
} from './app/pages/products/products.component';

import {
  OrdersComponent
} from './app/pages/orders/orders.component';

import {
  HomeComponent
} from './app/pages/home/home.component';

import {
  RegisterComponent
} from './app/pages/register/register.component';

import {
  CustomerLoginComponent
} from './app/pages/customer-login/customer-login.component';

import {
  CustomerRegisterComponent
} from './app/pages/customer-register/customer-register.component';

import {
  CustomerOrdersComponent
} from './app/pages/customer-orders/customer-orders.component';

import {
  DashboardDataComponent
} from './app/pages/dashboard-data/dashboard-data.component';

import {
  CashFlowComponent
} from './app/pages/cash-flow/cash-flow.component';

import {
  OrderTrackingComponent
} from './app/pages/order-tracking/order-tracking.component';

import {
  SettingsComponent
} from './app/pages/settings/settings.component';

import {
  PublicTableComponent
} from './app/pages/public-table/public-table.component';

import {
  TablesComponent
} from './app/pages/tables/tables.component';

import { SubscriptionComponent } from './app/pages/subscription/subscription.component';
import {
  CouponsComponent
} from './app/pages/coupons/coupons.component';

import {
  superAdminGuard
} from './app/core/super-admin.guard';
/*
 * Registra os dados de localização do Brasil.
 * Necessário para CurrencyPipe, DatePipe e DecimalPipe
 * usando o locale pt-BR.
 */
registerLocaleData(localePt);

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },





  {
    path: 'mesa/:publicToken',
    component: PublicTableComponent
  },

  {
    path: 'cardapio/:slug',
    component: PublicMenuComponent
  },

  {
    path: 'pedido/:trackingCode',
    component: OrderTrackingComponent
  },

  {
    path: 'login',
    component: LoginComponent
  },


  {
    path: 'esqueci-senha',

    loadComponent: () =>
      import(
        './app/pages/forgot-password/forgot-password.component'
      ).then(
        module =>
          module.ForgotPasswordComponent
      )
  },

  {
    path: 'redefinir-senha',

    loadComponent: () =>
      import(
        './app/pages/reset-password/reset-password.component'
      ).then(
        module =>
          module.ResetPasswordComponent
      )
  },



  {
    path: 'register',
    component: RegisterComponent
  },

  {
    path: 'customer/login',
    component: CustomerLoginComponent
  },

  {
    path: 'customer/register',
    component: CustomerRegisterComponent
  },

  {
    path: 'customer/orders',
    component: CustomerOrdersComponent
  },

  {
    path: 'accept-invitation/:token',

    loadComponent: () =>
      import(
        './app/pages/accept-invitation/accept-invitation.component'
      ).then(
        module =>
          module.AcceptInvitationComponent
      )
  },




  {
    path: 'superadmin',

    canActivate: [
      superAdminGuard
    ],

    loadComponent: () =>
      import(
        './app/pages/super-admin/super-admin-layout/super-admin-layout.component'
      ).then(
        module =>
          module.SuperAdminLayoutComponent
      ),

    children: [

      /*
       * /superadmin
       * redireciona para
       * /superadmin/dashboard
       */
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },

      /*
       * VISÃO GERAL
       */
      {
        path: 'dashboard',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-dashboard/super-admin-dashboard.component'
          ).then(
            module =>
              module.SuperAdminDashboardComponent
          )
      },

      /*
       * CLIENTES / USUÁRIOS
       */
      {
        path: 'clientes',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-users/super-admin-users.component'
          ).then(
            module =>
              module.SuperAdminUsersComponent
          )
      },

      {
        path: 'clientes/:id',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-user-details/super-admin-user-details.component'
          ).then(
            module =>
              module.SuperAdminUserDetailsComponent
          )
      },

      /*
       * RESTAURANTES
       */
      {
        path: 'restaurantes',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-restaurants/super-admin-restaurants.component'
          ).then(
            module =>
              module.SuperAdminRestaurantsComponent
          )
      },

      {
        path: 'restaurantes/:id',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-restaurant-details/super-admin-restaurant-details.component'
          ).then(
            module =>
              module.SuperAdminRestaurantDetailsComponent
          )
      },

      /*
       * ASSINATURAS
       */
      {
        path: 'assinaturas',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-subscriptions/super-admin-subscriptions.component'
          ).then(
            module =>
              module.SuperAdminSubscriptionsComponent
          )
      },


      {
        path: 'assinaturas/:id',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-subscription-details/super-admin-subscription-details.component'
          ).then(
            module =>
              module.SuperAdminSubscriptionDetailsComponent
          )
      },


      {
        path: 'recuperacao',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-recovery/super-admin-recovery.component'
          ).then(
            module =>
              module.SuperAdminRecoveryComponent
          )
      },



      /*
       * PLANOS
       */
      {
        path: 'planos',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-plans/super-admin-plans.component'
          ).then(
            module =>
              module.SuperAdminPlansComponent
          )
      },

      /*
       * PAGAMENTOS
       */
      {
        path: 'pagamentos',

        loadComponent: () =>
          import(
            './app/pages/super-admin/super-admin-payments/super-admin-payments.component'
          ).then(
            module =>
              module.SuperAdminPaymentsComponent
          )
      }

    ]
  },




{
  path: 'admin',
  component: DashboardComponent,
  canActivate: [authGuard],

  children: [

    {
      path: '',
      redirectTo: 'pedidos',
      pathMatch: 'full'
    },

    {
      path: 'assinatura',
      component: SubscriptionComponent
    },

    {
      path: 'cupons',
      component: CouponsComponent
    },

    {
      path: 'restaurantes',
      component: RestaurantsComponent
    },

    {
      path: 'dashboard',
      component: DashboardDataComponent
    },

    {
      path: 'fluxo-caixa',
      component: CashFlowComponent
    },

    {
      path: 'configuracoes',
      component: SettingsComponent
    },

    {
      path: 'produtos',
      component: ProductsComponent
    },

    {
      path: 'pedidos',
      component: OrdersComponent
    },

    {
      path: 'mesas',
      component: TablesComponent
    },

    {
      path: 'gerenciar-mesas',

      loadComponent: () =>
        import(
          './app/pages/table-management/table-management.component'
        ).then(
          module =>
            module.TableManagementComponent
        )
    },

    /* ==========================================
       CENTRAL DE AJUDA
       ========================================== */

    {
      path: 'tutorial',

      loadComponent: () =>
        import(
          './app/pages/tutorial/tutorial.component'
        ).then(
          module =>
            module.TutorialComponent
        )
    }

  ]
}
];

bootstrapApplication(
  AppComponent,
  {
    providers: [
      provideRouter(routes),

      provideHttpClient(
        withInterceptors([
          authInterceptor
        ])
      ),

      {
        provide: LOCALE_ID,
        useValue: 'pt-BR'
      }
    ]
  }
).catch(console.error);